import React from 'react';
import { FieldArray } from 'redux-form';
import { fieldRequired } from '../../../core/formValidation';
import VendorFormFields from './VendorFormFields';

const PurchaseOrderVendorForm = () => {
  return <FieldArray name="items" component={VendorFormFields} validate={[fieldRequired]} />;
};

export default PurchaseOrderVendorForm;
